export enum EEncoding {
    OLD = 'old',
    EPC = 'epc',
    NEW = 'new',
    NEW_IND = 'newInd'
}

export const EEncodingValues = [EEncoding.OLD, EEncoding.EPC, EEncoding.NEW, EEncoding.NEW_IND]

export const EEncodingOptions = EEncodingValues.map(label => ({ id: label, label }))
